import multipleSessionApi from '@/api/multipleSession'
import * as Sentry from '@sentry/vue'
import constants from '@/constant'

const SET_PRESENTATION_SESSIONS = 'SET_PRESENTATION_SESSIONS'
const SET_PAGINATION = 'SET_PAGINATION'
const UPDATE_PAGINATION = 'UPDATE_PAGINATION'
const SET_SHOW_MODAL_SESSION_EXPORT = 'SET_SHOW_MODAL_SESSION_EXPORT'
const SET_LOADING = 'SET_LOADING'
const SET_SELECTED_PRESENTATION = 'SET_SELECTED_PRESENTATION'
const SET_FIRST_LOAD_PAGE = 'SET_FIRST_LOAD_PAGE'
const RESET_FIRST_LOAD_PAGE = 'RESET_FIRST_LOAD_PAGE'

// state
const _state = {
  presentationSessions: [],
  pagination: {
    pageSize: constants.REPORT_SESSION.pageSize,
    current: 1,
  },
  loading: false,
  showModalSessionExport: false,
  selectedPresentation: {},
  firstLoadPage: null,
  // This is the to determine if the first ever load request has done
  initialLoadPage: false,
}

// getters
const _getters = {
}

// mutations
const mutations = {
  [SET_PRESENTATION_SESSIONS](state, presentationSessions) {
    state.presentationSessions = presentationSessions
  },
  [SET_PAGINATION](state, pagination) {
    state.pagination = pagination
  },
  [UPDATE_PAGINATION](state, pagination) {
    state.pagination = {
      ...state.pagination,
      ...pagination,
    }
  },
  [SET_SHOW_MODAL_SESSION_EXPORT](state, showModalSessionExport) {
    state.showModalSessionExport = showModalSessionExport
  },
  [SET_LOADING](state, loading) {
    state.loading = loading
  },
  [SET_SELECTED_PRESENTATION](state, selectedPresentation) {
    state.selectedPresentation = selectedPresentation
  },
  [SET_FIRST_LOAD_PAGE](state) {
    // This mutation transitions the page load state.
    // The flow is: null (initial) -> true (first load done) -> false (subsequent loads).
    if (state.firstLoadPage === null) {
      state.firstLoadPage = true
      return
    }
    state.firstLoadPage = false
  },
  [RESET_FIRST_LOAD_PAGE](state) {
    state.firstLoadPage = null
  },
  setinitialLoadPage(state, payload) {
    state.initialLoadPage = payload
  },
}

// actions
const actions = {
  async fetchReportSessionAction({ commit }, params) {
    commit(SET_LOADING, true)
    try {
      const response = await multipleSessionApi.getListSessionReportByPresentationId(params)
      commit(SET_PRESENTATION_SESSIONS, response.data.rows)
      commit(SET_PAGINATION, {
        pageSize: params.pageSize,
        current: params.page,
        total: response.data.total,
      })
      commit(SET_FIRST_LOAD_PAGE)
      commit('setinitialLoadPage', true)
    } catch (error) {
      Sentry.captureException(new Error('Sessions report error'), {
        extra: { error },
      })
    }
    commit(SET_LOADING, false)
  },
  setPresentationSessionsAction({ commit }, presentationSessions) {
    commit(SET_PRESENTATION_SESSIONS, presentationSessions)
  },
  setReportSessionPaginationAction({ commit }, pagination) {
    commit(SET_PAGINATION, pagination)
  },
  setShowModalSessionExportAction({ commit }, showModalSessionExport) {
    commit(SET_SHOW_MODAL_SESSION_EXPORT, showModalSessionExport)
  },
  setSelectedPresentationAction({ commit }, selectedPresentation) {
    commit(SET_SELECTED_PRESENTATION, selectedPresentation)
  },
  resetFirstLoadPageAction({ commit }) {
    commit(RESET_FIRST_LOAD_PAGE)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
